export default "__VITE_ASSET__ChcbarAm__"